/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { ERC20__factory } from "./ERC20__factory";
export { ERC721__factory } from "./ERC721__factory";
